angular.module('mediciones', [])
    .controller('medicionesController', ['$rootScope', '$scope', '$location', '$route', '$routeParams', 'medicionesService', 'authenticationInfo', 'authenticationService', '$sce',
        function ($rootScope, $scope, $location, $route, $routeParams, medicionesService, authenticationInfo, authenticationService, $sce) {

            var myChartAforadores;
            var myChartCaudales;
            var myChartInclinometros;
            var myChartPiezometros;
            var myChartPendulos;
            var myChartJuntas;
            //let myChartResto;

            $scope.infraestructurasId = $routeParams.id;

            medicionesService.getPresa($scope.infraestructurasId)
                .then(function (response) {
                    var data = response.data;
                    $scope.presaId = data;

                    medicionesService.getMedicionesAforadores($scope.presaId)
                        .then(function (response) {
                            var data = response.data;
                            $scope.aforadores = data;

                            if (myChartAforadores) {
                                myChartAforadores.destroy();
                            }

                            var ctx = document.getElementById('graficoAforadores').getContext('2d');

                            // Paleta de colores para diferenciar cada aforador
                            var colores = [
                                'rgba(255, 99, 132, 1)',  // rojo
                                'rgba(54, 162, 235, 1)',  // azul
                                'rgba(255, 206, 86, 1)',  // amarillo
                                'rgba(75, 192, 192, 1)',  // verde
                                'rgba(153, 102, 255, 1)', // morado
                                'rgba(255, 159, 64, 1)'   // naranja
                            ];

                            var labels = $scope.aforadores[0].Mediciones.map(function (m) {
                                return m.Fecha.split('T')[0];
                            });

                            // Construcción dinámica de datasets en ES5
                            var datasets = $scope.aforadores.map(function (aforador, index) {
                                return {
                                    label: aforador.Descripcion + " (" + aforador.Ubicacion + ")",
                                    data: aforador.Mediciones.map(function (m) {
                                        return m.Valor;
                                    }),
                                    borderColor: colores[index % colores.length],
                                    borderWidth: 2,
                                    showLine: true,
                                    fill: false
                                };
                            });

                            myChartAforadores = new Chart(ctx, {
                                type: 'line',
                                data: {
                                    labels: labels,
                                    datasets: datasets
                                },
                                options: {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    scales: {
                                        x: {
                                            type: 'category',
                                            title: { display: true, text: 'Fecha' }
                                        },
                                        y: {
                                            title: { display: true, text: 'Valor' }
                                        }
                                    }
                                }
                            });

                        });



                    medicionesService.getMedicionesCaudales($scope.presaId)
                        .then(function (response) {
                            var data = response.data;
                            $scope.caudales = data;

                            if (myChartCaudales) {
                                myChartCaudales.destroy();
                            }

                            var ctx = document.getElementById('graficoCaudales').getContext('2d');

                            // Paleta de colores para diferenciar cada aforador
                            var colores = [
                                'rgba(255, 99, 132, 1)',  // rojo
                                'rgba(54, 162, 235, 1)',  // azul
                                'rgba(255, 206, 86, 1)',  // amarillo
                                'rgba(75, 192, 192, 1)',  // verde
                                'rgba(153, 102, 255, 1)', // morado
                                'rgba(255, 159, 64, 1)'   // naranja
                            ];

                            var labels = $scope.caudales[0].Mediciones.map(function (m) {
                                return m.Fecha.split('T')[0];
                            });

                            // Construcción dinámica de datasets en ES5
                            var datasets = $scope.caudales.map(function (caudal, index) {
                                return {
                                    label: caudal.Descripcion + " (" + caudal.Ubicacion + ")",
                                    data: caudal.Mediciones.map(function (m) {
                                        return m.Valor;
                                    }),
                                    borderColor: colores[index % colores.length],
                                    borderWidth: 2,
                                    showLine: true,
                                    fill: false
                                };
                            });

                            myChartCaudales = new Chart(ctx, {
                                type: 'line',
                                data: {
                                    labels: labels,
                                    datasets: datasets
                                },
                                options: {
                                    scales: {
                                        x: {
                                            type: 'category',
                                            title: { display: true, text: 'Fecha' }
                                        },
                                        y: {
                                            title: { display: true, text: 'Valor' }
                                        }
                                    }
                                }
                            });

                        });



                    medicionesService.getMedicionesInclinometros($scope.presaId)
                        .then(function (response) {
                            var data = response.data;
                            $scope.inclinometros = data;

                            if (myChartInclinometros) {
                                myChartInclinometros.destroy();
                            }

                            var ctx = document.getElementById('graficoInclinometros').getContext('2d');

                            // Paleta de colores para diferenciar cada aforador
                            var colores = [
                                'rgba(255, 99, 132, 1)',  // rojo
                                'rgba(54, 162, 235, 1)',  // azul
                                'rgba(255, 206, 86, 1)',  // amarillo
                                'rgba(75, 192, 192, 1)',  // verde
                                'rgba(153, 102, 255, 1)', // morado
                                'rgba(255, 159, 64, 1)'   // naranja
                            ];

                            var labels = $scope.inclinometros[0].Mediciones.map(function (m) {
                                return m.Fecha.split('T')[0];
                            });

                            // Construcción dinámica de datasets en ES5
                            var datasets = $scope.inclinometros.map(function (inclinometro, index) {
                                return {
                                    label: inclinometro.Descripcion + " (" + inclinometro.Ubicacion + ")",
                                    data: inclinometro.Mediciones.map(function (m) {
                                        return m.Valor;
                                    }),
                                    borderColor: colores[index % colores.length],
                                    borderWidth: 2,
                                    showLine: true,
                                    fill: false
                                };
                            });

                            myChartInclinometros = new Chart(ctx, {
                                type: 'line',
                                data: {
                                    labels: labels,
                                    datasets: datasets
                                },
                                options: {
                                    scales: {
                                        x: {
                                            type: 'category',
                                            title: { display: true, text: 'Fecha' }
                                        },
                                        y: {
                                            title: { display: true, text: 'Valor' }
                                        }
                                    }
                                }
                            });

                        });


                    medicionesService.getMedicionesJuntas($scope.presaId)
                        .then(function (response) {
                            var data = response.data;
                            $scope.juntas = data;

                            // Esperar a que Angular pinte los canvas
                            setTimeout(function () {
                                dibujarGraficasJuntas($scope.juntas);
                            }, 0);

                        });



                    medicionesService.getMedicionesPendulos($scope.presaId)
                        .then(function (response) {
                            var data = response.data;
                            $scope.pendulos = data;

                            if (myChartPendulos) {
                                myChartPendulos.destroy();
                            }

                            var ctx = document.getElementById('graficoPendulos').getContext('2d');

                            // Paleta de colores para diferenciar cada péndulo
                            var colores = [
                                'rgba(255, 99, 132, 1)',
                                'rgba(54, 162, 235, 1)',
                                'rgba(255, 206, 86, 1)',
                                'rgba(75, 192, 192, 1)',
                                'rgba(153, 102, 255, 1)',
                                'rgba(255, 159, 64, 1)'
                            ];

                            // Construcción dinámica de datasets
                            var datasets = $scope.pendulos.map(function (pendulo, index) {
                                // ordenar por fecha
                                var medicionesOrdenadas = pendulo.Mediciones.sort(function (a, b) {
                                    return new Date(a.Fecha) - new Date(b.Fecha);
                                });

                                return {
                                    label: pendulo.Descripcion + " (" + pendulo.Ubicacion + ")",
                                    data: medicionesOrdenadas.map(function (m) {
                                        return {
                                            x: Number(m.CoordenadaX),
                                            y: Number(m.CoordenadaY),
                                            label: new Date(m.Fecha).toLocaleDateString() // etiqueta tooltip
                                        };
                                    }),
                                    borderColor: colores[index % colores.length],
                                    borderWidth: 2,
                                    showLine: true,   // <- dibuja líneas entre los puntos
                                    fill: false,
                                    tension: 0,       // 0 = líneas rectas, >0 = curvas suaves
                                    pointRadius: 4,
                                    pointHoverRadius: 6
                                };
                            });

                            myChartPendulos = new Chart(ctx, {
                                type: 'scatter',
                                data: { datasets: datasets },
                                options: {
                                    plugins: {
                                        tooltip: {
                                            enabled: false // desactiva tooltip flotante
                                        },
                                        datalabels: {
                                            align: 'top',
                                            anchor: 'end',
                                            font: { size: 10 },
                                            formatter: function (value, context) {
                                                // Aquí puedes devolver lo que quieras como "tooltip fijo"
                                                // Ejemplo: solo fecha
                                                return value.label;

                                                // Ejemplo: fecha con coordenadas
                                                // return value.label + " (" + value.x + ", " + value.y + ")";
                                            }
                                        }
                                    },
                                    scales: {
                                        x: {
                                            type: 'linear',
                                            title: { display: true, text: 'Coordenada X' },
                                            ticks: {
                                                callback: function (value) { return Number(value).toFixed(2); }
                                            }
                                        },
                                        y: {
                                            type: 'linear',
                                            title: { display: true, text: 'Coordenada Y' },
                                            ticks: {
                                                callback: function (value) { return Number(value).toFixed(2); }
                                            }
                                        }
                                    }
                                },
                                plugins: [ChartDataLabels]  // <- activas el plugin aquí
                            });

                        });



                    medicionesService.getMedicionesPiezometros($scope.presaId)
                        .then(function (response) {
                            var data = response.data;
                            $scope.piezometros = data;

                            if (myChartPiezometros) {
                                myChartPiezometros.destroy();
                            }

                            var ctx = document.getElementById('graficoPiezometros').getContext('2d');

                            // Paleta de colores para diferenciar cada aforador
                            var colores = [
                                'rgba(255, 99, 132, 1)',  // rojo
                                'rgba(54, 162, 235, 1)',  // azul
                                'rgba(255, 206, 86, 1)',  // amarillo
                                'rgba(75, 192, 192, 1)',  // verde
                                'rgba(153, 102, 255, 1)', // morado
                                'rgba(255, 159, 64, 1)'   // naranja
                            ];

                            var labels = $scope.piezometros[0].Mediciones.map(function (m) {
                                return m.Fecha.split('T')[0];
                            });

                            // Construcción dinámica de datasets en ES5
                            var datasets = $scope.piezometros.map(function (piezometro, index) {
                                return {
                                    label: piezometro.Descripcion + " (" + piezometro.Ubicacion + ")",
                                    data: piezometro.Mediciones.map(function (m) {
                                        return m.Valor;
                                    }),
                                    borderColor: colores[index % colores.length],
                                    borderWidth: 2,
                                    showLine: true,
                                    fill: false
                                };
                            });

                            myChartPiezometros = new Chart(ctx, {
                                type: 'line',
                                data: {
                                    labels: labels,
                                    datasets: datasets
                                },
                                options: {
                                    scales: {
                                        x: {
                                            type: 'category',
                                            title: { display: true, text: 'Fecha' }
                                        },
                                        y: {
                                            title: { display: true, text: 'Valor' }
                                        }
                                    }
                                }
                            });
                        });

                    medicionesService.getMedicionesOtras($scope.presaId)
                        .then(function (response) {
                            var data = response.data;
                            $scope.resto = data;

                            setTimeout(function () {
                                dibujarGraficasResto($scope.resto);
                            }, 0);

                        });
                });




            function dibujarGraficasResto(data) {
                data.forEach(function (tipo, index) {
                    var ctx = document.getElementById("graficoResto" + index).getContext("2d");

                    var dataset = {
                        label: tipo.Descripcion,
                        data: tipo.Mediciones.map(function (m) {
                            return {
                                x: m.Fecha.split('T')[0], // eje X: fecha (solo YYYY-MM-DD)
                                y: m.Valor
                            };
                        }),
                        borderColor: 'rgba(54, 162, 235, 1)',
                        borderWidth: 2,
                        fill: false,
                        showLine: true
                    };

                    new Chart(ctx, {
                        type: 'scatter',
                        data: { datasets: [dataset] },
                        options: {
                            scales: {
                                x: {
                                    type: 'category',
                                    title: { display: true, text: 'Fecha' }
                                },
                                y: {
                                    title: { display: true, text: 'Valor' }
                                }
                            }
                        }
                    });
                });
            }


            function dibujarGraficasJuntas(juntas) {
                // Paleta de colores para distinguir juntas
                var colores = [
                    'rgba(255, 99, 132, 1)',   // rojo
                    'rgba(54, 162, 235, 1)',   // azul
                    'rgba(255, 206, 86, 1)',   // amarillo
                    'rgba(75, 192, 192, 1)',   // verde
                    'rgba(153, 102, 255, 1)',  // morado
                    'rgba(255, 159, 64, 1)'    // naranja
                ];

                // Construir datasets para cada coordenada
                var datasetsX = [];
                var datasetsY = [];
                var datasetsZ = [];

                juntas.forEach(function (junta, index) {
                    var datosX = junta.Mediciones.map(function (m) {
                        return { x: m.Fecha.split('T')[0], y: parseFloat(m.CoordenadaX) };
                    });
                    var datosY = junta.Mediciones.map(function (m) {
                        return { x: m.Fecha.split('T')[0], y: parseFloat(m.CoordenadaY) };
                    });
                    var datosZ = junta.Mediciones.map(function (m) {
                        return { x: m.Fecha.split('T')[0], y: parseFloat(m.CoordenadaZ) };
                    });

                    datasetsX.push({
                        label: junta.Descripcion + " (" + junta.Ubicacion + ")",
                        data: datosX,
                        borderColor: colores[index % colores.length],
                        borderWidth: 2,
                        fill: false
                    });

                    datasetsY.push({
                        label: junta.Descripcion + " (" + junta.Ubicacion + ")",
                        data: datosY,
                        borderColor: colores[index % colores.length],
                        borderWidth: 2,
                        fill: false
                    });

                    datasetsZ.push({
                        label: junta.Descripcion + " (" + junta.Ubicacion + ")",
                        data: datosZ,
                        borderColor: colores[index % colores.length],
                        borderWidth: 2,
                        fill: false
                    });
                });

                // Gráfico X
                new Chart(document.getElementById("graficoJuntasX"), {
                    type: 'line',
                    data: { datasets: datasetsX },
                    options: {
                        responsive: true,
                        plugins: { legend: { position: 'bottom' } },
                        scales: {
                            x: { type: 'category', title: { display: true, text: 'Fecha' } },
                            y: { title: { display: true, text: 'Coordenada X' } }
                        }
                    }
                });

                // Gráfico Y
                new Chart(document.getElementById("graficoJuntasY"), {
                    type: 'line',
                    data: { datasets: datasetsY },
                    options: {
                        responsive: true,
                        plugins: { legend: { position: 'bottom' } },
                        scales: {
                            x: { type: 'category', title: { display: true, text: 'Fecha' } },
                            y: { title: { display: true, text: 'Coordenada Y' } }
                        }
                    }
                });

                // Gráfico Z
                new Chart(document.getElementById("graficoJuntasZ"), {
                    type: 'line',
                    data: { datasets: datasetsZ },
                    options: {
                        responsive: true,
                        plugins: { legend: { position: 'bottom' } },
                        scales: {
                            x: { type: 'category', title: { display: true, text: 'Fecha' } },
                            y: { title: { display: true, text: 'Coordenada Z' } }
                        }
                    }
                });
            }




        }
    ]);